import SignupForm from 'features/login/SignupForm';

const SignupPage = () => {
	return (
		<div>
			<SignupForm />
		</div>
	);
};

export default SignupPage;
